import { eventService } from 'srcReact/services'
import { commonActions } from 'srcReact/components'
import { rsvpConstants as rc } from './constants'

export const rsvpActions = {
  updateAttendance,
  rejectInvitation,
  clearData
}

function updateAttendance(mixrId, attending, recurrenceAttending = 'none') {
  return (dispatch) => {
    dispatch(request(mixrId))

    eventService.updateAttendingMixr(mixrId, attending, recurrenceAttending).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? { ...response.banner_data, mixrId: mixrId } : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: rc.UPDATE_ATTENDANCE_REQUEST, response }
  }
  function success(response) {
    return { type: rc.UPDATE_ATTENDANCE_SUCCESS, response, mixrId, recurrenceAttending }
  }
  function failure(error) {
    return { type: rc.UPDATE_ATTENDANCE_FAILURE, error }
  }
}

function rejectInvitation(mixrId) {
  return (dispatch) => {
    dispatch(request(mixrId))

    eventService.rejectInvitation(mixrId).then(
      (response) => {
        dispatch(success(response))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: rc.REJECT_INVITATION_REQUEST, response }
  }
  function success(response) {
    return { type: rc.REJECT_INVITATION_SUCCESS, response, mixrId }
  }
  function failure(error) {
    return { type: rc.REJECT_INVITATION_FAILURE, error }
  }
}

function clearData() {
  return { type: rc.CLEAR_DATA }
}
